import { useDispatch, useSelector } from 'react-redux';
import { setBehaviorData } from '@store';

export const useBehaviorData = () => {
  const dispatch = useDispatch();
  const { behaviorData } = useSelector((state) => state.policy);

  const setData = (info) => {
    dispatch(setBehaviorData({ ...behaviorData, ...info }));
  };

  return setData;
};
